import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Cohorts from "./pages/Cohorts";
import Quizzes from "./pages/Quiz";
import Evaluations from "./pages/Evaluations";
import EvaluationDetails from "./pages/EvaluationDetails";
import Breadcrumb from "./components/Breadcrumb";
import { Box } from "@mui/material";
import MasterSolutions from "./pages/MasterSolutions";
import ListOfCohorts from "./pages/ListOfCohorts";
import Dashboard from "./pages/Dashboard";
import ListOfQuizzes from "./pages/ListOfQuizzes";
import DashboardEvaluations from "./pages/DashboardEvaluations";
import DashboardEvaluationDetails from "./pages/DashboardEvaluationDetails";

function AppRouter() {
  return (
    <Router>
      {/* <Breadcrumb /> */}
      <Routes>
        <Route path="/" element={<Cohorts />} />
        <Route path="/cohort/:cohortId" element={<CohortLayout />}>
          <Route path="quizzes" element={<Quizzes />} />
          <Route path="quiz/:quizId/evaluations" element={<Evaluations />} />
          <Route path="quiz/:quizId/evaluation/:evaluationId/evaluation-details" element={<EvaluationDetails />} />
        </Route>
        <Route path="/masterSolution" element={<MasterSolutionLayout />}>
          <Route index element={<MasterSolutions />} />
          <Route path="/masterSolution/:masterId/list-of-cohorts" element={<ListOfCohorts />} /> {/* New Route */}
        </Route>

        {/* <Route path="/performanceDashboard" element={<PerformanceDashboardLayout />}>
      <Route index element={<Dashboard />} />
      <Route path="/performanceDashboard/listOfQuizzes" element={<ListOfQuizzes />} />
      <Route
            path="/performanceDashboard/listOfQuizzes/cohort/:courseId/quiz/:quizId/evaluations"
            element={<DashboardEvaluations />}
          />
          <Route path="performanceDashboard/listOfQuizzes/cohort/:courseId/quiz/:quizId/evaluation/:evaluationId/evaluation-details" element={<DashboardEvaluationDetails/>} />
    </Route> */}
        <Route path="/performanceDashboard" element={<PerformanceDashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="listOfQuizzes" element={<ListOfQuizzes />} />
          <Route path="listOfQuizzes/cohort/:courseId/quiz/:quizId/evaluations" element={<DashboardEvaluations />} />
          <Route path="listOfQuizzes/cohort/:courseId/quiz/:quizId/evaluation/:evaluationId/evaluation-details" element={<DashboardEvaluationDetails />} />
        </Route>
      </Routes>
    </Router>
  );
}

function CohortLayout() {
  return (
    <Box pt={4} >
      <Breadcrumb />
      <Outlet />
    </Box>
  );
}
function MasterSolutionLayout() {
  return (
    <Box pt={4}>
      <Breadcrumb />
      <Outlet />
    </Box>
  );
}

const PerformanceDashboardLayout = () => {
  return (
    <Box pt={4}>
      <Breadcrumb />
      <Outlet />
    </Box>
  );
}


export default AppRouter;
